import * as moment from "moment";

// Organize work order chart data

export const returnChartData = (data: any): Array<any> => {
  if (!data || !data.length) {
    return [];
  }

  let chartData: any = [];

  const allMonths = moment.monthsShort();

  // filter requests based on month it was created

  // January
  const janrequests = data.filter(
    (request: any) => moment(request.createdAt).format("MMM") === allMonths[0]
  );

  const janData = {
    name: allMonths[0],
    Received: !janrequests.length ? 0 : janrequests.length,
    Accepted: !janrequests.length
      ? 0
      : janrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: janrequests.length
  };

  chartData = [...chartData, janData];

  // February
  const febrequests = data.filter(
    (request: any) => moment(request.createdAt).format("MMM") === allMonths[1]
  );

  const febData = {
    name: allMonths[1],
    Received: !febrequests.length ? 0 : febrequests.length,
    Accepted: !febrequests.length
      ? 0
      : febrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: febrequests.length
  };

  chartData = [...chartData, febData];

  // March
  const marrequests = data.filter(
    (request: any) => moment(request.createdAt).format("MMM") === allMonths[2]
  );

  const marData = {
    name: allMonths[2],
    Received: !marrequests.length ? 0 : marrequests.length,
    Accepted: !marrequests.length
      ? 0
      : marrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: marrequests.length
  };

  chartData = [...chartData, marData];

  // April
  const aprrequests = data.filter(
    (request: any) => moment(request.createdAt).format("MMM") === allMonths[3]
  );

  const aprData = {
    name: allMonths[3],
    Received: !aprrequests.length ? 0 : aprrequests.length,
    Accepted: !aprrequests.length
      ? 0
      : aprrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: aprrequests.length
  };

  chartData = [...chartData, aprData];

  // May
  const mayrequests = data.filter(
    (request: any) => moment(request.createdAt).format("MMM") === allMonths[4]
  );

  const mayData = {
    name: allMonths[4],
    Received: !mayrequests.length ? 0 : mayrequests.length,
    Accepted: !mayrequests.length
      ? 0
      : mayrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: mayrequests.length
  };

  chartData = [...chartData, mayData];

  // June
  const junrequests = data.filter(
    (request: any) => moment(request.createdAt).format("MMM") === allMonths[5]
  );

  const junData = {
    name: allMonths[5],
    Received: !junrequests.length ? 0 : junrequests.length,
    Accepted: !junrequests.length
      ? 0
      : junrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: junrequests.length
  };

  chartData = [...chartData, junData];

  // July
  const julrequests = data.filter(
    (request: any) => moment(request.createdAt).format("MMM") === allMonths[6]
  );

  const julData = {
    name: allMonths[6],
    Received: !julrequests.length ? 0 : julrequests.length,
    Accepted: !julrequests.length
      ? 0
      : julrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: julrequests.length
  };

  chartData = [...chartData, julData];

  // August
  const augrequests = data.filter(
    (request: any) => moment(request.createdAt).format("MMM") === allMonths[7]
  );

  const augData = {
    name: allMonths[7],
    Received: !augrequests.length ? 0 : augrequests.length,
    Accepted: !augrequests.length
      ? 0
      : augrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: augrequests.length
  };

  chartData = [...chartData, augData];

  // September
  const seprequests = data.filter(
    (request: any) => moment(request.createdAt).format("MMM") === allMonths[8]
  );

  const sepData = {
    name: allMonths[8],
    Received: !seprequests.length ? 0 : seprequests.length,
    Accepted: !seprequests.length
      ? 0
      : seprequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: seprequests.length
  };

  chartData = [...chartData, sepData];

  // October
  const octrequests = data.filter(
    (request: any) => moment(request.createdAt).format("MMM") === allMonths[9]
  );

  const octData = {
    name: allMonths[9],
    Received: !octrequests.length ? 0 : octrequests.length,
    Accepted: !octrequests.length
      ? 0
      : octrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: octrequests.length
  };

  chartData = [...chartData, octData];

  // November
  const novrequests = data.filter(
    (request: any) => moment(request.createdAt).format("MMM") === allMonths[10]
  );

  const novData = {
    name: allMonths[10],
    Received: !novrequests.length ? 0 : novrequests.length,
    Accepted: !novrequests.length
      ? 0
      : novrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: novrequests.length
  };

  chartData = [...chartData, novData];

  // December
  const decrequests = data.filter(
    (request: any) => moment(request.createdAt).format("MMM") === allMonths[11]
  );

  const decData = {
    name: allMonths[11],
    Received: !decrequests.length ? 0 : decrequests.length,
    Accepted: !decrequests.length
      ? 0
      : decrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: decrequests.length
  };

  chartData = [...chartData, decData];

  return chartData;
};

// Organize and return chart data
export const returnWeekChartData = (data: any): Array<any> => {
  if (!data || !data.length) {
    return [];
  }

  let chartData: any = [];

  // Get the current week
  const startOfWeek = moment().startOf("week");
  const endOfWeek = moment().endOf("week");

  const days: any = [];
  let day = startOfWeek;

  while (day <= endOfWeek) {
    days.push(day.toDate());
    day = day.clone().add(1, "d");
  }

  const allRequests = data;

  // filter requests based on the day it was created

  // Sunday
  const sunrequests = allRequests.filter(
    (request: any) =>
      moment(request.createdAt).format("DD/MM/YYYY") ===
      moment(days[0]).format("DD/MM/YYYY")
  );

  const sunData = {
    name: moment(days[0]).format("ddd"),
    Received: !sunrequests.length ? 0 : sunrequests.length,
    Accepted: !sunrequests.length
      ? 0
      : sunrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: sunrequests.length
  };

  chartData = [...chartData, sunData];

  // Monday
  const monrequests = allRequests.filter(
    (request: any) =>
      moment(request.createdAt).format("DD/MM/YYYY") ===
      moment(days[1]).format("DD/MM/YYYY")
  );

  const monData = {
    name: moment(days[1]).format("ddd"),
    Received: !monrequests.length ? 0 : monrequests.length,
    Accepted: !monrequests.length
      ? 0
      : monrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: monrequests.length
  };

  chartData = [...chartData, monData];

  // Tuesday
  const tuerequests = allRequests.filter(
    (request: any) =>
      moment(request.createdAt).format("DD/MM/YYYY") ===
      moment(days[2]).format("DD/MM/YYYY")
  );

  const tueData = {
    name: moment(days[2]).format("ddd"),
    Received: !tuerequests.length ? 0 : tuerequests.length,
    Accepted: !tuerequests.length
      ? 0
      : tuerequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: tuerequests.length
  };

  chartData = [...chartData, tueData];

  // Wednesday
  const wedrequests = allRequests.filter(
    (request: any) =>
      moment(request.createdAt).format("DD/MM/YYYY") ===
      moment(days[3]).format("DD/MM/YYYY")
  );

  const wedData = {
    name: moment(days[3]).format("ddd"),
    Received: !wedrequests.length ? 0 : wedrequests.length,
    Accepted: !wedrequests.length
      ? 0
      : wedrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: wedrequests.length
  };

  chartData = [...chartData, wedData];

  // Thursday
  const thurequests = allRequests.filter(
    (request: any) =>
      moment(request.createdAt).format("DD/MM/YYYY") ===
      moment(days[4]).format("DD/MM/YYYY")
  );

  const thuData = {
    name: moment(days[4]).format("ddd"),
    Received: !thurequests.length ? 0 : thurequests.length,
    Accepted: !thurequests.length
      ? 0
      : thurequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: thurequests.length
  };

  chartData = [...chartData, thuData];

  // Friday
  const frirequests = allRequests.filter(
    (request: any) =>
      moment(request.createdAt).format("DD/MM/YYYY") ===
      moment(days[5]).format("DD/MM/YYYY")
  );

  const friData = {
    name: moment(days[5]).format("ddd"),
    Received: !frirequests.length ? 0 : frirequests.length,
    Accepted: !frirequests.length
      ? 0
      : frirequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: frirequests.length
  };

  chartData = [...chartData, friData];

  // Saturday
  const satrequests = allRequests.filter(
    (request: any) =>
      moment(request.createdAt).format("DD/MM/YYYY") ===
      moment(days[6]).format("DD/MM/YYYY")
  );

  const satData = {
    name: moment(days[6]).format("ddd"),
    Received: !satrequests.length ? 0 : satrequests.length,
    Accepted: !satrequests.length
      ? 0
      : satrequests.filter((request: any) => request.status === "ACCEPT")
          .length,
    amt: satrequests.length
  };

  chartData = [...chartData, satData];

  return chartData;
};



// WEBPACK FOOTER //
// ./src/Containers/Reports/CustomerRequestsCharts/Utils.ts